/**
 * FanAvatar.tsx — monogram avatar derived from the fan's id/name (Design Spec §09).
 *
 * The active fan's avatar fills with the accent; otherwise it shows an
 * accent-tinted monogram on a soft fill. Monogram is mono-spaced (machine data).
 */

import * as React from 'react';
import { fanMonogram } from '../lib/format.js';

type AvatarSize = 'sm' | 'md' | 'lg';

const SIZE: Record<AvatarSize, string> = {
  sm: 'w-9 h-9 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-16 h-16 text-xl',
};

interface FanAvatarProps {
  nickname?: string | null;
  username?: string | null;
  fanId?: string | null;
  size?: AvatarSize;
  active?: boolean;
}

export function FanAvatar({
  nickname,
  username,
  fanId,
  size = 'md',
  active = false,
}: FanAvatarProps) {
  const text = fanMonogram({ nickname, username, fanId });
  return (
    <span
      aria-hidden="true"
      className={[
        'inline-flex items-center justify-center rounded-lg font-mono font-semibold shrink-0 select-none',
        SIZE[size],
        active ? 'bg-accent text-white' : 'bg-accent/10 text-accent',
      ].join(' ')}
    >
      {text}
    </span>
  );
}
